import { createApp } from "vue"; // Importação correta para Vue 3
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueTheMask from "vue-the-mask";
import Icon from "@/components/icons/Icon.vue";
import { setupVersionChecker } from "./version-checker"; // Importar o verificador de versão
import TelefoneInternacional from "@/components/TelefoneInternacional.vue";
import "../node_modules/vue-tel-input/dist/vue-tel-input.css";
import InputNome from "@/components/form/InputNome.vue";
import AlertPlugin from "@/composables/useAlert";
import { resolvePublicAssetUrl } from "@/utils/publicAssetUrl";

// PrimeVue
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import Select from "primevue/select";

// Tailwind CSS
import "@/assets/css/tailwind.css";

require("@/store/subscriber");

// Cria a aplicação Vue e passa a instância do App.vue
const app = createApp(App);

/* eslint-disable vue/multi-word-component-names */
app.component("Icon", Icon);

app.component("InputNome", InputNome);

app.component("telefone-internacional", TelefoneInternacional);

// Registra o Vue Router com a aplicação Vue
app.use(router);

// Registra o Vuex store com a aplicação Vue
app.use(store);

app.use(VueSweetalert2);

app.use(VueTheMask);

app.use(AlertPlugin);

// PrimeVue com tema Aura
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: ".dark",
    },
  },
});

// Register PrimeVue components
app.component("InputText", InputText);
app.component("Password", Password);
app.component("Button", Button);
app.component("Checkbox", Checkbox);
app.component("Select", Select);

// Monta a aplicação Vue no elemento com id #app no seu index.html
app.mount("#app");

// PWA: Registrar Service Worker
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    const serviceWorkerUrl = resolvePublicAssetUrl(
      "service-worker.js",
      process.env.BASE_URL,
    );
    const serviceWorkerScope = resolvePublicAssetUrl("", process.env.BASE_URL);
    navigator.serviceWorker
      .register(serviceWorkerUrl, { scope: serviceWorkerScope })
      .catch((error) => {
        console.log("SW registration failed:", error);
      });
  });
}

// Inicializar o verificador de versão após a montagem do aplicativo
setupVersionChecker(5); // Verificar a cada 5 minutos

// Se você precisar despachar uma ação ao iniciar, faça isso após montar a aplicação
store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  // Qualquer lógica adicional que precisa ser executada após o despacho da ação
});

// store.dispatch('auth/attemptUser', localStorage.getItem('user')).then(() => {
//   // Qualquer lógica adicional que precisa ser executada após o despacho da ação
// });
